import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'

import { IProps } from './IProps'
import { RequiredTextWrapper, RequiredText, RequiredIcon } from './style'

export const RequiredMessages: FunctionComponent<IProps> = ({ errors }) => {
  const { t } = useTranslation()
  if (Object.entries(errors).length === 0) {
    return null
  }

  // TODO can you write this witout ignore?

  return (
    <>
      {Object.entries(errors).map(([key]) => (
        <RequiredTextWrapper>
          <RequiredIcon icon="circle-exclamation" />
          {/* @ts-ignore */}
          <RequiredText>{t(errors[key].message)}</RequiredText>
        </RequiredTextWrapper>
      ))}
    </>
  )
}
